export const DepartmentAll = `query {
            allDepartment {
                id
                departmentName
                departmentCode
            }
        }`;

export const DesignationAll = `query{
      allDesignation{
        id
        departmentName
        designation
        lastUpdate
      }
    }`;

export const LeaveConfigAll = `query allLeaveConfigurations{
  allLeaveConfigurations {
    id
    leaveType
    numberOfDays
    allowNegative
    maximumNegativeDays
    maximumConsecutiveDays
    networkDays
    leaveWithoutPay
    eligibleProbation
    eligibleIntern
    accrualMethod
    allocationDay
    roundOff
    carryover
    carryoverLimit
    carryoverExpiry
    expiryLimit
    encashment
    maximumEncashmentDays
    lastUpdate
  }
}`;

export const ShiftALL = ` query allShifts{
  allShifts {
    id
    name
    startTime
    endTime
  }
}`;

export const OTMasterALL = ` query OT {
      allOt {
        id
        maximumHours
        otPerhourCharge
      }
    }`;

export const Allrolequery = `query{
      allRoles{
        data{
          id
          role
          description
        }
      }
    }`;

export const CategoryCreate = `mutation createcategory($input:CreateCategoryInput!){ 
    
      createCategory(input:$input){ 
    
        success 
    
        message 
    
      } 
    
    } `;
export const CategoryUpdate = `mutation updatecategory($input:UpdateCategoryInput!){ 

  updateCategory(input:$input){ 

    success 

    message 

  } 

} `

export const allcategoryquery = `query { 

  allCategory { 
    id 
    category 
    categoryrolesSet { 
      id 
      roles { 
        id 
        role  
      } 

    } 

    createdAt 

    user { 

      username 

    } 

  } 

} `;

export const GetIDCategory =  `query getcategorybyid($id:ID!){ 

  getCategoryById(id:$id){ 

    id 

    category 

    categoryrolesSet{ 

      id 

      roles{ 

        id 

        role 

      } 

    } 

  } 

} `

export const CategoryDelete = `mutation deletecategory($id:ID!) { 

  deleteCategory(id: $id) { 

    success 

    message 

  } 

} `